import {Component, Inject, OnDestroy, OnInit, ViewChild, Output,Input, EventEmitter} from '@angular/core';
import {NgIf} from "@angular/common";
import {CdkDrag, CdkDragDrop, CdkDropList} from "@angular/cdk/drag-drop";
import {GuidelineTileComponent} from "../../../playbooks/add-edit-playbook/guideline-tile/guideline-tile.component";
import {NgScrollbar} from "ngx-scrollbar";
import {
    FormArray,
    FormGroupDirective,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from "@angular/forms";
import {TranslocoDirective} from "@jsverse/transloco";
import {Subject} from "rxjs";
import {
    IAddEditPlaybookFacade,
    IAddEditPlaybookFacadeToken
} from "../../../playbooks/add-edit-playbook/add-edit-playbook.facade";
import { LHSubmitFormButtonTranslationKey } from '../legal-hub-side-bar';
import { CoreDirectivesModule } from '@core/directives/directives';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-legal-hub-guidelines-tab',
  standalone: true,
    imports: [
        CdkDropList, 
        CdkDrag,
        GuidelineTileComponent,
        NgIf,
        NgScrollbar,
        ReactiveFormsModule,
        CoreDirectivesModule,
        TranslocoDirective,
        SharedModule
    ],
  templateUrl: './legal-hub-guidelines-tab.component.html',
  styleUrl: './legal-hub-guidelines-tab.component.scss'
})
export class LegalHubGuidelinesTabComponent implements OnInit, OnDestroy{
    private unsubscribe$: Subject<void> = new Subject<void>();

    public playbookForm: UntypedFormGroup;
    @Input() public submitted: boolean = false;
    @ViewChild('guideLineScroll', {static: false}) scrollArea?: NgScrollbar;
    @Output() public submitClicked: EventEmitter<void> = new EventEmitter<void>();


    constructor( private _formBuilder: UntypedFormBuilder,
                 private hostFrom: FormGroupDirective,
                 private _activeModal: NgbActiveModal,
                 @Inject(IAddEditPlaybookFacadeToken) protected _addEditPlaybookFacadeService:IAddEditPlaybookFacade,
                 @Inject(LHSubmitFormButtonTranslationKey) public submitButtonTranslationKey: string) {
        this.playbookForm = this.hostFrom.form;
    }


    ngOnInit(): void {
        this.playbookForm = this.hostFrom.form;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    
    closeSiderBar(){
        this._activeModal.close({refresh_listing: false});
    }


    onSubmit(){
        this.submitted = true;
        this.submitClicked.emit();
    }


    addNewGuidelineClicked(){
        const index = this.guidelines ?  (<FormArray>this.guidelines).length : 0;
        this.addNewGuideline(null, this.playbookId,  '', index);
        setTimeout(() => {
            this.scrollToBottom();
        });
    }

    removeGuideline(index: number){
        (<FormArray>this.playbookForm?.get('guidelines')).removeAt(index);
        const guidelines = (<FormArray>this.playbookForm?.get('guidelines'))
        for (let i = 0; i< guidelines.length; i++) {
            guidelines.at(i).get('order')?.setValue(i);
        }
    }

    get guidelines(){
        return this.playbookForm?.get('guidelines') ? this.playbookForm?.controls.guidelines : {controls: []};
    }
    
    get playbookId(): number {
        return this.playbookForm?.get('id')?.value;
    }

    
    get hasBlankGuideline(){
        return this?.playbookForm?.value?.guidelines?.some(x=>x.content?.trim().length === 0);
    }

    drop(event: CdkDragDrop<string[]>) {

        const dir = event.currentIndex > event.previousIndex ? 1 : -1;
        const from = event.previousIndex;
        const to = event.currentIndex;

        const temp = (<FormArray>this.playbookForm?.controls.guidelines).at(from);
        temp.get('order')?.setValue(to);
        for (let i = from; i * dir < to * dir; i = i + dir) {
            const current = (<FormArray>this.playbookForm?.controls.guidelines).at(i + dir);
            current.get('order')?.setValue(i);
            (<FormArray>this.playbookForm?.controls.guidelines).setControl(i, current);
        }
        (<FormArray>this.playbookForm?.controls.guidelines).setControl(to, temp);

    }

    protected addNewGuideline(id:number, playbook_id:number, content:string, index:number){
        (<FormArray>this.playbookForm?.get('guidelines'))
            .push(this._formBuilder.group({
                id:[id ],
                playbook_id: [playbook_id],
                content: [content, [Validators.required, Validators.minLength(1)]],
                order: [index, Validators.required]
            }))
    }

    private scrollToBottom() {
        if (this.scrollArea) {
            this.scrollArea.scrollTo({bottom:0, duration: 300});
        }
    }
}
